import { render, staticRenderFns } from "./ReactionTestsTabNewQuestion.vue?vue&type=template&id=17e9722e&"
import script from "./ReactionTestsTabNewQuestion.vue?vue&type=script&lang=js&"
export * from "./ReactionTestsTabNewQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ReactionTestsTabNewQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReactionTestsTabNewQuestion.vue"
export default component.exports